<template>
  <div class="flex h-full w-full justify-center items-center">
    <SkeletonLoader v-if="loading" :page="loaderPages.TABLE" />
    <div v-else-if="linkedInLogs?.length > 0" class="h-full w-full">
      <CustomTable
        height="(90vh - var(--banner-height))"
        :headers="linkedInLogHeaders"
        :data="linkedInLogs"
        :custom-column-render="customColumnRender"
        :show-actions-column="false"
        :pagination="pagination"
        :show-checkboxes="true"
        :selection="selection"
        identifier-key="id"
        @update:pagination="handlePageChange"
        @update:selection="handleSelectionUpdate"
        :toShowActions="() => {}"
        prefixImageBorderRadius="0%"
        :source="source"
        :show-select-all="source !== entityTypes.SEQUENCE_LINKEDIN_LOGS"
        :custom-row="customRow"
      />
    </div>
    <EmptyScreen
      v-else
      source="linkedin_logs_table"
      text="No LinkedIn logs found!"
    />
  </div>
</template>

<script setup>
import CustomTable from "@/src/components/custom_table_components/CustomTable.vue";
import ActivityType from "@/src/components/linkedin_logs/renderers/ActivityType.vue";
import SentToLinkedIn from "@/src/components/linkedin_logs/renderers/SentToLinkedIn.vue";
import ActivityContent from "@/src/components/linkedin_logs/renderers/ActivityContent.vue";
import LinkedInEngagement from "@/src/components/linkedin_logs/renderers/LinkedInEngagement.vue";
import SenderAccount from "@/src/components/linkedin_logs/renderers/SenderAccount.vue";
import SentOnLinkedIn from "@/src/components/linkedin_logs/renderers/SentOnLinkedIn.vue";
import { loaderPages } from "@/src/constants/loaderConstants.js";
import SkeletonLoader from "@/src/components/SkeletonLoader.vue";
import EmptyScreen from "@/src/components/EmptyScreen.vue";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";

const props = defineProps({
  linkedInLogs: { type: Array, required: true },
  pagination: { type: Object, required: true },
  loading: { type: Boolean, required: true },
  handlePageChange: { type: Function, required: true },
  selection: { type: Object, required: true },
  source: { type: String, required: true },
});

const emit = defineEmits(["update:selection"]);

const linkedInLogHeaders = [
  { label: "Activity Type", key: "activity_type", width: 2 },
  { label: "Sent To", key: "sent_to", width: 2 },
  { label: "Activity", key: "activity", width: 5 },
  { label: "Engagement", key: "engagement", width: 2 },
  { label: "Sender", key: "sender", width: 1 },
  { label: "Sent On", key: "sent_on", width: 2 },
];

const handleSelectionUpdate = (newSelection) => {
  emit("update:selection", newSelection);
};

const customRow = (row) => {
  const contactId = row.contact_id;
  const leadId = row.lead_id;

  let href = "#";
  if (contactId) {
    href = `/contacts/${contactId}`;
  } else if (leadId) {
    href = `/leads/${leadId}`;
  }

  return {
    onClick: (event) => {
      const target = event.target;
      const isCheckbox =
        target.type === "checkbox" ||
        target.closest(".ant-checkbox") ||
        target.closest('[role="checkbox"]') ||
        target.closest(".checkbox-cell");

      if (isCheckbox) {
        return;
      }

      if (contactId || leadId) {
        window.open(
          window.location.origin + href,
          "_blank",
          "noopener,noreferrer",
        );
      }
    },
    "data-href": href,
  };
};

const customColumnRender = {
  activity_type: ActivityType,
  sent_to: SentToLinkedIn,
  activity: ActivityContent,
  engagement: LinkedInEngagement,
  sender: SenderAccount,
  sent_on: SentOnLinkedIn,
};
</script>
